import { graphql } from '../../graphql';

export const getStaticFooterData = graphql(`
  query StaticFooterData {
    ...FooterDataFields
  }
`);

export const getStaticDataQuery = graphql(`
  query StaticData {
    ...FooterDataFields

    categories {
      ...CategoryFields
    }
  }
`);
